// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"739":"301e8d32","2119":"15989307","2378":"6d27f051","2958":"3b53517f","3087":"f8aef58c","7533":"301e8d32"}[chunkId] + ".chunk.css";
};